import React, { useState, useRef, useEffect } from "react";
import '../css/footer-form.css';
import GravityFormForm from 'gatsby-plugin-gravity-forms-ignitro'


// Modal component
const Modal = ({ isOpen, onClose, onSubmit, data, presetEmail }) => {
  const [email, setEmail] = useState(presetEmail);
  const [company, setCompany] = useState("");
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);
  
  useEffect(() => {
    setEmail(presetEmail);
  }, [presetEmail]);
  
  console.log('modal', presetEmail);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ email, company });
    setEmail("");
    setCompany("");
    onClose();
  };

  return (
    <div className="modal-container">
    <div className={`modal ${isOpen ? "open" : ""}`}>
      <div className="modal-content" ref={modalRef}>
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Sign Up</h2>
        <GravityFormForm data={data} presetValues={{ input_1: presetEmail }}></GravityFormForm>
        {/* <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email:</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Company:</label>
            <input type="text" value={company} onChange={(e) => setCompany(e.target.value)} />
          </div>
          <button type="submit">Submit</button> 
  </form>*/}
      </div>
    </div>
    </div>
  );
};

// Main component
const FooterForm = ({data}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [presetEmail, setPresetEmail] = useState(""); // State to store the preset email value

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = ({ email, company }) => {
    // Handle form submission here
    console.log("Email:", email);
    console.log("Company:", company);
    // Close the modal after successful submission
    handleModalClose();
  };

  return (
    
    <React.Fragment>
      <div className="container footerForm">
        <div className="grid smallGrid align-center">
          <div className="maincopy">
            <div id="sign-up">
            <p>Sign up for our latest articles and events.</p>
            </div>
            <div id="form">
              <form>
              <div className="form-group">
                  <input type="email" value={presetEmail} onChange={(e) => setPresetEmail(e.target.value)} placeholder="Enter Your Email"/>
                </div>
              </form>
              </div>
            <div className="footerFormRight">
            <button onClick={handleModalOpen}>Sign Up</button>
          </div>
          </div>
          
        </div>
      </div>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={handleModalClose} onSubmit={handleSubmit} data={data} presetEmail={presetEmail} />
      )}
    </React.Fragment>
  );
};

export default FooterForm;
